export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [P in K]?: T[P];
};

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

/** Narrows unknown input to a string containing non-whitespace characters. */
export const isNonBlankString = (value: unknown): value is string =>
  typeof value === 'string' && value.trim().length > 0;

/**
 * Narrows an external array without introducing untyped elements.
 * @param value - Unvalidated value.
 * @returns Whether it is an array whose elements still require validation.
 */
export const isUnknownArray = (value: unknown): value is unknown[] =>
  Array.isArray(value);
